import Link from 'next/link'

const CATEGORIES: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Snorkeling',         href: '/katalog/snorkeling' },
  { label: 'Freediving',         href: '/katalog/freediving' },
  { label: 'Nurkowanie',         href: '/katalog/nurkowanie' },
  { label: 'Łowiectwo podwodne', href: '/katalog/lowiectwo-podwodne' },
]

interface Props {
  title?: string
  extras?: ReadonlyArray<{ label: string; href: string }>
}

export function CategoryChips({ title, extras }: Props) {
  return (
    <div className="w-full">
      {title && (
        <p
          className="text-xs font-bold uppercase tracking-widest mb-3 text-center"
          style={{ color: 'rgba(255,255,255,0.4)', fontFamily: 'var(--font-heading)' }}
        >
          {title}
        </p>
      )}
      <div className="flex flex-wrap gap-2 justify-center">
        {CATEGORIES.map((l) => (
          <Link key={l.href} href={l.href} className="search-pill px-3 py-1.5 rounded-full text-xs font-medium">
            {l.label}
          </Link>
        ))}
        {extras?.map((l) => (
          <Link key={l.href} href={l.href} className="search-pill px-3 py-1.5 rounded-full text-xs font-medium">
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
